import React, { Component } from 'react'

import 'intl-tel-input/styles'
import intlTelInput from 'intl-tel-input'

class IntPhoneInput extends Component {
  componentDidMount() {
    this.iti = intlTelInput(this.el, {
      initialCountry: 'us',
      loadUtils: () => import('intl-tel-input/utils'),
    })
  }

  componentDidUpdate() {
    if (this.props.phone === '') {
      this.el.value = ''
    }
  }

  componentWillUnmount() {
    this.iti.destroy()
  }

  render() {
    return (
      <input
        ref={(el) => (this.el = el)}
        className="form-control"
        type="tel"
        onChange={() => this.props.changeHandler(this.iti)}
      />
    )
  }
}

export default IntPhoneInput
